import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';
import RequireAuth from './lib/auth/RequireAuth';
import Error404 from './routes/errors/Error404';
import Error500 from './routes/errors/Error500';
import Home from './routes/home/Home';
import Login from './routes/login/Login';
import AppLayout from './AppLayout';
import reportWebVitals from './reportWebVitals';
import Register from './routes/register/Register';
import RegisterForm from './routes/register/RegisterForm';
import App from './App';
import { Logout } from './routes/logout/Logout';
import CampaignsListView from './routes/campaigns/list/CampaignsListView';
import CampaignStepper from './routes/campaigns/edit/CampaignStepper';
import CampaignLeadsView from './routes/campaigns/edit/leads/LeadsView';
import SequencesView from './routes/campaigns/edit/sequences/SequencesView';
import ParametersView from './routes/campaigns/edit/parameters/ParametersView';
import CopyrightingView from './routes/campaigns/edit/copyrighting/CopyrightingView';

// Router Config
const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <Error500 />,
    children: [
      {
        path: '/',
        element: (
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        ),
        children: [
          {
            index: true,
            element: <Home />
          },
          {
            path: 'campaign',
            children: [
              {
                index: true,
                element: <CampaignsListView />
              },
              {
                path: ':campaignId',
                element: <CampaignStepper />,
                children: [
                  {
                    path: 'leads',
                    element: <CampaignLeadsView />
                  },
                  {
                    path: 'sequences',
                    element: <SequencesView />
                  },
                  {
                    path: 'parameters',
                    element: <ParametersView />
                  },
                  {
                    path: 'copywriting',
                    element: <CopyrightingView />
                  }
                ]
              }
            ]
          },
          // {
          //   path: 'company-settings',
          //   element: <Home />
          // },
          // {
          //   path: 'profile',
          //   element: <ProfileView />
          // },
          {
            path: '/logout',
            element: <Logout />
          }
        ]
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/register',
        element: <Register />,
        children: [
          {
            index: true,
            element: <RegisterForm />
          },
        ]
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
]);

document.getElementById('css-root')?.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
